import { getColor } from "@utils/func/colorTool";
import { YStack, XStack, Text } from "tamagui";

interface FamilySpending {
  label: string;
  e: string;
  color: string;
  amount: number;
}

export const FamilyExpenses = ({ data }: { data: FamilySpending[] }) => {
  const total = data.reduce((sum, item) => sum + item.amount, 0);

  return (
    <YStack bg="white" br="$4" p="$4">
      <XStack jc="space-between" ai="center" mb="$4">
        <YStack>
          <Text fow="700" fontSize={14}>
            各帳戶瓦斯開銷
          </Text>
          <Text color="$hintColor" fontSize={11} mt="$1">
            本月 04/01 - 04/30
          </Text>
        </YStack>
        <YStack ai="flex-end">
          <Text color="$hintColor" fontSize={11}>
            總支出
          </Text>
          <Text color="$blue10" fow="800" fontSize={17}>
            NT$ {total.toLocaleString()}
          </Text>
        </YStack>
      </XStack>

      {/* 堆疊比例條 */}
      <XStack h={10} br="$10" ov="hidden" bg="$borderColor" mb="$4">
        {data.map((item, i) => (
          <YStack key={item.label} w={`${(item.amount / total) * 100}%`} bg={getColor(i).color} h="100%" />
        ))}
      </XStack>

      {/* 詳細列表 */}
      <YStack gap="$2.5">
        {data.map((item, i) => (
          <XStack key={item.label} ai="center" gap="$3">
            <YStack w={26} h={26} br="$2" bg={getColor(i).bgColor} ai="center" jc="center">
              <Text color={getColor(i).color} fow="700" fontSize={11}>
                {item.e}
              </Text>
            </YStack>
            <Text f={1} fow="500" fontSize={13}>
              {item.label}
            </Text>
            <Text color="$hintColor" fontSize={12}>
              {Math.round((item.amount / total) * 100)}%
            </Text>
            <Text fow="700" fontSize={14} w={80} ta="right" fontFamily="$numeric">
              NT$ {item.amount.toLocaleString()}
            </Text>
          </XStack>
        ))}
      </YStack>
    </YStack>
  );
};

export default FamilyExpenses;
